import React from 'react';

import { Button, useMantineTheme, createStyles, Text, TextInput, ActionIcon, Space } from '@mantine/core';
import { IconPlus, IconChevronDown, IconSearch, IconX } from '@tabler/icons-react';
import { AthleteDocumentSearchFilters } from 'pages/private/owner/AthleteDetail/components/Documents/types';

const useStyles = createStyles(theme => ({
  header: {
    display: 'grid',
    gridTemplateColumns: 'auto auto min-content min-content',
    gridTemplateAreas: `
			'title title waiver contract'
			'filters filters filters filters'
		`,
    alignItems: 'center',
    gap: theme.spacing.sm,
    paddingBottom: theme.spacing.sm,
  },
  filters: {
    gridArea: 'filters',
  },
  title: {
    gridArea: 'title',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: theme.spacing.lg,
  },
  waiver: {
    gridArea: 'waiver',
  },
  contract: {
    gridArea: 'contract',
  },
}));

const AthleteDocumentsHeader = ({
  searchFilters,
  setSearchFilters,
  openTabsDrawer,
  openCreateWaiver,
  openCreateContract,
  permission = true,
}: {
  searchFilters: AthleteDocumentSearchFilters;
  setSearchFilters: React.Dispatch<React.SetStateAction<AthleteDocumentSearchFilters>>;
  openTabsDrawer: () => void;
  openCreateWaiver: () => void;
  openCreateContract: () => void;
  permission?: boolean;
}): JSX.Element => {
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e?.currentTarget?.value || '';
    setSearchFilters(prev => ({ ...prev, search: value }));
  };
  const handleClearFilters = (): void => {
    setSearchFilters({ ...searchFilters, search: '' });
  };

  return (
    <div className={classes.header}>
      <Text size='md' fw='bold' className={classes.title} onClick={openTabsDrawer}>
        Documents
        <IconChevronDown size={16} style={{ marginLeft: 4 }} />
      </Text>
      <Button
        className={classes.waiver}
        onClick={openCreateWaiver}
        leftIcon={<IconPlus size={theme.fontSizes.md} />}
        size='xs'
        disabled={!permission}
      >
        Waiver
      </Button>
      <Button
        className={classes.contract}
        onClick={openCreateContract}
        leftIcon={<IconPlus size={theme.fontSizes.md} />}
        size='xs'
        disabled={!permission}
      >
        Contract
      </Button>
      <TextInput
        placeholder='Search by description'
        icon={<IconSearch size={theme.fontSizes.md} />}
        onChange={handleSearchChange}
        value={searchFilters.search}
        className={classes.filters}
        rightSection={
          !!searchFilters.search ? (
            <ActionIcon onClick={handleClearFilters} size='md'>
              <IconX size={theme.fontSizes.md} />
            </ActionIcon>
          ) : (
            <Space />
          )
        }
      />
    </div>
  );
};

export default AthleteDocumentsHeader;
